import apiManager from './apiManager'
const getStatusHistory = async (id) => {
	const statusHistory = apiManager.axios
		.get(`v1/admin/agent/${id}/agentStatusHistory`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return statusHistory
}

const getWorkingHistory = async (id) => {
	const workingHistory = apiManager.axios
		.get(`/v1/admin/agent/${id}/workingHistory`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return workingHistory
}
export default {
	getStatusHistory,
	getWorkingHistory,
}
